import { useState } from 'react';
import { toast } from 'react-toastify';
import { useLoaderStore } from '../../stores/loader.store';
import thankYouService from '../../Services/thank-you.service';

export function EditThankYou({ thankyou, onEditSuccess }) {
    const setShowLoader = useLoaderStore((state) => state.setShowLoader);
    const [email, setEmail] = useState(thankyou.createdUserData?.email || "");

    async function editThankyou() {
        setShowLoader(true);

        try {
            const res = await thankYouService.updateThankyou(thankyou._id, {
                createdUserData: {
                    email: email
                }
            });

            if (res.status === 200) {
                toast.success("Successfully updated thankyou");
                onEditSuccess();
                return;
            }

            toast.error("Couldn't update thankyou");
        } catch (err) {
            console.log(err);
            toast.error("Couldn't update thankyou");
        } finally {
            setShowLoader(false);
        }
    }

    return (
        <div style={{ maxWidth: '600px', maxHeight: '650px', overflowY: "auto" }} className='p-2'>
            <div className="mb-2">
                <div className="d-flex mb-2">
                    <div className='w-50'>
                        <span className="cstm-label">From</span>
                        <p>{thankyou.createdUserData?.firstName}</p>
                    </div>
                </div>
            </div>

            <div className="mb-2">
                <label className="cstm-label">Sender Email</label>
                <input
                    type="text"
                    className="cstm-input"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                />
            </div>

            <div className="d-flex justify-content-end">
                <button type='button' className='cstm-submitbutton' onClick={editThankyou}>Save</button>
            </div>
        </div>
    );
}
